<template>
     <el-dialog custom-class="new-dialog-class" :top="top" :title="title" :visible.sync="dialogVisible" @close="close" width="500px" :close-on-click-modal="false" :show-close="false">
        <el-form :model="formData" :rules="rules" ref="form" size="mini" label-width="120px">
            <el-form-item v-if="type==='edit'" label="客户ID" prop="">
                <el-input v-model="formData.id" :disabled="true" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item> 
            <!-- 未定义变量 -->
            <el-form-item v-if="type==='edit'" label="商户号" prop="">
                <el-input v-model="formData.api_key" :disabled="true" type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item> 
            <!-- 未定义变量 -->
            <el-form-item v-if="type==='edit'" label="商户密钥" prop="">
                <el-input v-model="formData.api_secret" :disabled="true" type="password" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item> 
            <!-- 未定义变量 -->
            <el-form-item v-if="type==='edit'" label="AES密钥" prop="">
                <el-input v-model="formData.aes_secret" :disabled="true" type="password" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item> 
            <el-form-item label="客户昵称" prop="nickname" >
                <el-input  prefix-icon="el-icon-edit-outline" v-model="formData.nickname" clearable type="text" placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item>     
            <el-form-item label="客户邮箱" prop="email" >
                <el-input v-model="formData.email" type="text" clearable placeholder="请输入" size="mini" class="dialog-div-input"></el-input>
            </el-form-item>      
            <el-form-item v-if="type==='new' " label="客户余额" prop="balance">
                <el-input v-model="formData.balance" type="text" placeholder="请输入" size="mini" class="dialog-div-input">
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>    
            <el-form-item v-if="type==='edit'" label="状态" prop="">
                <el-switch v-model="formData.statusBoolean" active-text="启用" inactive-text="禁用"> </el-switch>
            </el-form-item> 
            
        </el-form>        
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">取 消</el-button>
            <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
 export default {
    name: 'CustomerEdit',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false,
        },
        loading:{
            type: Boolean,
            default: false,
        },
        title:{
            type: String,
            default: '',
        },
        top:{
            type: String,
            default: '15vh',
        },
        form:{
            type: Object,            
            required:true,
            default:{},            
        },
        type:{
            type: String,
            default: 'add',
        },      

    },
    mounted() { 
        for (const key in this.form) {
            if(key !== 'loading'){
                this.$set(this.formData, key, this.form[key]);
            }
            
        }
        // this.$set(this.formData);



    },
    data(){
        
            //昵称验证
            const checkNickname = function(rule, val, callback) {
                if(val){
                    if(val.length < 2 || val.length > 10){
                        return callback(new Error("名称长度不得少于 2 个字符，最多 10 个字符"));
                    }
                    if (/^\d+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(val)) {
                        callback(new Error('名称只能包含中英文和数字，请重新输入'));
                    } else {
                        callback();
                    }
                }
            };
            //邮箱长度验证
            const validateEmail = (rule, val, callback) => {
                if(val){
                    if(val.length > 100){
                        callback(new Error('邮箱长度不能超过100个字符'));
                    } else {
                        callback();
                    }
                }
            };
            const validateBalance = (rule, val, callback) => {
                if(val.length > 9){
                    callback(new Error('最多支持 9 位数字输入，请重试'));
                }else if (!/^\d{0,9}$/.test(val)){
                    callback(new Error('最多支持 9 位数字输入，请重试'));
                }else{
                    callback();
                }

                
            };
        return {
            rules:{
                    nickname:[
                        { required: true, message: '名称不能为空', trigger: 'blur' },
                        {validator:checkNickname, trigger: 'blur'},
                    ],
                    email:[
                        { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
                        { validator: validateEmail, trigger: 'blur' }
                    ],
                    balance:[{ validator :validateBalance,trigger:'blur'}],
                    editBalance:[ { required: false, message: '请输入邮箱地址', trigger: 'blur' },]
            },
            formData:{
            },
        }
    },
    methods: {        
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        close(){            
            this.resetForm('form')
            this.$emit("close");
        },
        sure(){
            this.$refs['form'].validate((valid) => {
                    if (valid) {          
                        this.formData.status = this.formData.statusBoolean ? 1 : 0;              
                        this.$emit("sure",this.formData)
                       
                    } else {
                        return false;
                    }
                });    
        }
    }

 }
</script>
<style lang="scss" scoped>
//  .dialog-div{
//     .dialog-div-input{
//         width: 200px;
//     }
//     .dialog-btn{
//         margin-left: 15px;
//         width: 80px;
//     }
//     .balance-dialog-class{
//         .balance-detail-page{
//             margin-top: 40px;
//             justify-content:flex-end;
//         }
//     }
// }
</style>